import { createAction as createReduxAction, createRoutine as createReduxRoutine } from "Utils/Redux";

const createAction = <T extends string, P = void>(type: T) => createReduxAction<
	T, P, "DATABASE"
>(type, "DATABASE");

const createRoutine = <
	T extends string,
	TriggerPayload = void,
	RequestPayload = void,
	SuccessPayload = void,
	FailurePayload = void,
	FulfillPayload = void
>(type: T) => createReduxRoutine<
	T,
	TriggerPayload,
	RequestPayload,
	SuccessPayload,
	FailurePayload,
	FulfillPayload,
	"DATABASE"
>(type, "DATABASE");

export default {
	INITIATE: createAction("INITIATE"),
	UNINITIATE: createAction("UNINITIATE"),
};
